<template>
  <SocialsBody/>
</template>

<script>
// @ is an alias to /src
import SocialsBody from '@/components/SocialsBody.vue'

export default {
  name: 'SocialsView',
  components: {
    SocialsBody
  }
}
</script>
